import { render, staticRenderFns } from "./PWS02G02.vue?vue&type=template&id=03cf8dd0&scoped=true"
import script from "./PWS02G02.vue?vue&type=script&lang=js"
export * from "./PWS02G02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf8dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03cf8dd0')) {
      api.createRecord('03cf8dd0', component.options)
    } else {
      api.reload('03cf8dd0', component.options)
    }
    module.hot.accept("./PWS02G02.vue?vue&type=template&id=03cf8dd0&scoped=true", function () {
      api.rerender('03cf8dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pws/PWS02G02.vue"
export default component.exports